export enum Mood {
  PEACEFUL = 'Peaceful',
  ROMANTIC = 'Romantic',
  SENTIMENTAL = 'Sentimental',
  TENDER = 'Tender',
  EASYGOING = 'Easygoing',
  YEARNING = 'Yearning',
  SOPHISTICATED = 'Sophisticated',
  SENSUAL = 'Sensual',
  COOL = 'Cool',
  GRITTY = 'Gritty',
  MELANCHOLY = 'Melancholy',
  SERIOUS = 'Serious',
  BROODING = 'Brooding',
  FIERY = 'Fiery',
  DEFIANT = 'Defiant',
  AGGRESSIVE = 'Aggressive',
  ROWDY = 'Rowdy',
  EXCITED = 'Excited',
  ENERGIZING = 'Energizing',
  EMPOWERING = 'Empowering',
  STIRRING = 'Stirring',
  UPBEAT = 'Upbeat',
  OTHER = 'Other'
}
